<template>
  <div class="accordion" :data-testid="label + '-accordion-container'">
    <div class="accordion-item">
      <div
        class="accordion-trigger"
        :class="{ open: active }"
        :aria-label="label + ' Accordion Trigger'"
        :data-testid="label + '-accordion-trigger'"
        @click="toggle"
      >
        <md-icon class="trigger-icon" data-testid="accordion-arrow-icon">arrow_right</md-icon>
        <div class="trigger-label" data-testid="accordion-label">{{ label }}</div>
        <md-button
          v-if="removeable"
          class="md-icon-button md-primary md-raised md-dense"
          aria-label="Remove Scene"
          data-testid="remove-scene-button"
          @click="remove"
        >
          <md-icon>remove</md-icon>
        </md-button>
      </div>
    </div>
    <transition name="fold">
      <div v-show="active" class="accordion-content" :data-testid="label + '-accordion-content'">
        <slot />
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'accordion',
  props: {
    active: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: null,
    },
    removeable: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    remove() {
      this.$emit('remove');
    },
    toggle() {
      this.$emit('toggle');
    },
  }
}
</script>

<style scoped>
.accordion {
  display: flex;
  flex-direction: column;
}

.accordion-item {
  display: flex;
  flex-direction: column;
  margin-bottom: 15px;
}

.accordion-trigger {
  background-color: #fcfcfd !important;
  margin: 0;
  text-align: left;
  height: 40px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  box-shadow: 0 3px 1px -2px rgba(0,0,0,.2),0 2px 2px 0 rgba(0,0,0,.14),0 1px 5px 0 rgba(0,0,0,.12);
  border-radius: 5px;
}

.accordion-trigger.open .trigger-icon {
  transform: rotateZ(90deg);
}

.accordion-trigger label {
  vertical-align: middle;
}

.accordion-content {
  background-color: #fcfcfd;
  margin-left: 20px;
  margin-bottom: 16px;
  box-shadow: 2px 2px 8px rgba(0, 0, 0, 0.25);
  border-radius: 0px 0px 4px 4px;
  margin-top: -10px;
  padding-top: 10px;
  overflow: auto;
  flex: 1;
  max-height: 600px;
}

.accordion-trigger .trigger-label {
  flex: 1;
  font-size: 16px;
}


.fold-enter-active,
.fold-leave-active {
  transition: max-height 0.5s;
}
.fold-enter, .fold-leave-to /* .fade-leave-active below version 2.1.8 */ {
  max-height: 0;
}

.fold-enter-to,
.fold-leave {
  max-height: 300px;
}
</style>